/**
 * Simple Pre-Packs injects SPP_* globals with Shopify app-snippet HTML comment
 * wrappers that break JS parsing. Repair listing + PDP pack data, then nudge
 * the app to re-process.
 */
(function () {
  var STORAGE_KEY = 'spp_listing_units_v1';
  var unitsFetchInFlight = null;
  var hydrateInFlight = null;

  // Theme owns the selling price (+ optional strike). Keep pack meta only.
  function preferThemePriceSettings() {
    var settings = window.SPP_SETTINGS || (window.SPP_SETTINGS = {});
    settings.showPrice = false;
    settings.replaceListingPrice = false;

    document.querySelectorAll('.spp-pack-info-price').forEach(function (el) {
      el.remove();
    });

    // Undo Pre-Packs hiding the theme price when it was set to render its own.
    document
      .querySelectorAll(
        '.product__info-container .price[data-spp-hidden="true"], .product__info-container [id^="price-"][data-spp-hidden="true"], .card-information .price[data-spp-hidden="true"]',
      )
      .forEach(function (el) {
        el.removeAttribute('data-spp-hidden');
        el.style.removeProperty('display');
      });
  }

  function stripHtmlComments(text) {
    return String(text || '').replace(/<!--[\s\S]*?-->/g, '');
  }

  // App snippets leave `"totalUnits": <!-- ... -->` or empty values that break JSON.
  function sanitizeCompositionsJson(json) {
    return stripHtmlComments(json).replace(/"totalUnits"\s*:\s*(?=}|,)/g, '"totalUnits": 0');
  }

  function extractObjectLiteral(source, name) {
    var cleaned = stripHtmlComments(source);
    var nameIdx = cleaned.indexOf(name);
    if (nameIdx === -1) return null;

    var eqIdx = cleaned.indexOf('=', nameIdx);
    if (eqIdx === -1) return null;

    var start = cleaned.indexOf('{', eqIdx);
    if (start === -1) return null;

    var depth = 0;
    var inString = false;
    var escaped = false;
    var quote = '';

    for (var i = start; i < cleaned.length; i += 1) {
      var ch = cleaned.charAt(i);

      if (inString) {
        if (escaped) {
          escaped = false;
        } else if (ch === '\\') {
          escaped = true;
        } else if (ch === quote) {
          inString = false;
        }
        continue;
      }

      if (ch === '"' || ch === "'") {
        inString = true;
        quote = ch;
        continue;
      }

      if (ch === '{') {
        depth += 1;
      } else if (ch === '}') {
        depth -= 1;
        if (depth === 0) {
          return sanitizeCompositionsJson(cleaned.slice(start, i + 1));
        }
      }
    }

    return null;
  }

  function findInlineScript(marker) {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i += 1) {
      var text = scripts[i].textContent || '';
      if (text.indexOf(marker) !== -1) return text;
    }
    return '';
  }

  function parseAssignment(source, name) {
    var json = extractObjectLiteral(source, name);
    if (!json) return null;
    try {
      return JSON.parse(json);
    } catch (error) {
      return null;
    }
  }

  function readUnitsCache() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writeUnitsCache(map) {
    var payload = JSON.stringify(map);
    try {
      localStorage.setItem(STORAGE_KEY, payload);
    } catch (error) {
      try {
        sessionStorage.setItem(STORAGE_KEY, payload);
      } catch (ignore) {
        /* ignore quota / private mode */
      }
    }
  }

  function cacheListingUnits(compositions) {
    if (!compositions || typeof compositions !== 'object') return;
    var cache = readUnitsCache();
    var handles = Object.keys(compositions);
    for (var i = 0; i < handles.length; i += 1) {
      var handle = handles[i];
      var units = sumEntryUnits(compositions[handle]);
      if (units > 0) cache[handle] = units;
    }
    writeUnitsCache(cache);
  }

  function mergeListingCompositions(parsed) {
    if (!parsed || typeof parsed !== 'object') return;
    window.SPP_LISTING_COMPOSITIONS = window.SPP_LISTING_COMPOSITIONS || {};
    Object.keys(parsed).forEach(function (handle) {
      var units = sumEntryUnits(parsed[handle]);
      if (!(units > 0)) return;
      window.SPP_LISTING_COMPOSITIONS[handle] = Object.assign({}, parsed[handle], {
        totalUnits: units,
      });
    });
    cacheListingUnits(window.SPP_LISTING_COMPOSITIONS);
  }

  function unitsForHandle(handle) {
    if (!handle) return 0;
    var listing = window.SPP_LISTING_COMPOSITIONS;
    if (listing && listing[handle]) {
      var listed = sumEntryUnits(listing[handle]);
      if (listed > 0) return listed;
    }
    return Number(readUnitsCache()[handle]) || 0;
  }

  function repairListingCompositions() {
    var source = findInlineScript('SPP_LISTING_COMPOSITIONS');
    var parsed = source ? parseAssignment(source, 'SPP_LISTING_COMPOSITIONS') : null;

    // Prefer a freshly sanitized parse. The live assignment often throws because
    // app snippets inject HTML comments (and empty totalUnits) into the object.
    if (parsed && Object.keys(parsed).length) {
      var existing = window.SPP_LISTING_COMPOSITIONS;
      var before = existing && typeof existing === 'object' ? Object.keys(existing).length : 0;
      mergeListingCompositions(parsed);
      var after = Object.keys(window.SPP_LISTING_COMPOSITIONS || {}).length;
      return before !== after || !existing;
    }

    var existing = window.SPP_LISTING_COMPOSITIONS;
    if (existing && typeof existing === 'object' && Object.keys(existing).length > 0) {
      cacheListingUnits(existing);
    }
    return false;
  }

  function listingLabels() {
    var labels = window.SPP_LISTING_LABELS || {};
    return {
      perPrepackSingular: labels.perPrepackSingular || 'per prepack (1 piece)',
      perPrepackPlural: labels.perPrepackPlural || 'per prepack ({{ count }} pieces)',
      perPiece: labels.perPiece || '{{ price }} per piece',
    };
  }

  function findListingCards() {
    var cards = [];
    var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      if (!match) return;

      // Recently Viewed wraps the whole card in the product <a>, so the link
      // itself is the card. Don't fall back to the shared grid parent.
      var card = null;
      if (
        link.matches('[class*="ai-recently-viewed-product"]') ||
        link.querySelector('.price, [class*="product-price"]')
      ) {
        card = link;
      } else {
        card = link.closest(
          '.product-card-wrapper, .card-wrapper, .card--product, [data-product-card], li.grid__item, .grid__item',
        );
      }
      if (!card) card = link.parentElement;
      if (!card || (seen && seen.has(card))) return;
      if (seen) seen.add(card);
      cards.push({ card: card, handle: decodeURIComponent(match[1]), link: link });
    });
    return cards;
  }

  function findCardPriceRoot(card) {
    if (!card) return null;
    return (
      card.querySelector(
        '.card-information .price, [class*="ai-recently-viewed-product-price"], .price, .card__price, [data-product-price]',
      ) || null
    );
  }

  function ensurePlusOneMarkup(priceRoot, baseCents) {
    if (!priceRoot || !Number.isFinite(baseCents)) return null;
    var plus = priceRoot.querySelector('.price-item--plus-one[data-price-cents]');
    if (plus) return plus;

    var regular =
      priceRoot.querySelector('.price-item--regular, .price-item--sale') || priceRoot;
    plus = document.createElement('span');
    plus.className = 'price-item--plus-one';
    plus.setAttribute('data-price-cents', String(baseCents));
    plus.setAttribute('data-pack-units', '0');
    plus.textContent = formatMoney(baseCents + 100);
    regular.appendChild(plus);
    return plus;
  }

  function writeCardPackMeta(entry, units) {
    if (!(units > 0) || !entry || !entry.card) return false;

    var priceRoot = findCardPriceRoot(entry.card);
    if (!priceRoot) return false;

    var meta = priceRoot.parentNode
      ? priceRoot.parentNode.querySelector(':scope > .spp-listing-pack-meta')
      : null;
    if (!meta) {
      meta =
        priceRoot.nextElementSibling &&
        priceRoot.nextElementSibling.classList.contains('spp-listing-pack-meta')
          ? priceRoot.nextElementSibling
          : null;
    }
    if (!meta) {
      meta = document.createElement('div');
      meta.className = 'spp-listing-pack-meta';
      priceRoot.insertAdjacentElement('afterend', meta);
    }

    var labels = listingLabels();
    var base = resolvePackPriceCents(priceRoot, meta);
    var plus = ensurePlusOneMarkup(priceRoot, base);
    if (plus && Number.isFinite(base)) {
      var struck = formatMoney(base + units * 100);
      if (struck && plus.textContent !== struck) plus.textContent = struck;
      plus.setAttribute('data-pack-units', String(units));
      plus.setAttribute('data-price-cents', String(base));
    }

    var perPack =
      units === 1
        ? labels.perPrepackSingular
        : String(labels.perPrepackPlural).replace('{{ count }}', String(units));
    var html = '<span class="spp-listing-per-pack">' + perPack + '</span>';
    if (base != null) {
      var perPiece = formatMoney(Math.round(base / units));
      if (perPiece) {
        html +=
          '<span class="spp-listing-per-piece">' +
          String(labels.perPiece).replace('{{ price }}', perPiece) +
          '</span>';
      }
    }
    if (meta.innerHTML !== html) meta.innerHTML = html;
    meta.setAttribute('data-pack-units', String(units));
    return true;
  }

  function seedUnitsFromRenderedCardMeta() {
    document.querySelectorAll('.spp-listing-pack-meta[data-pack-units]').forEach(function (meta) {
      var units = Number(meta.getAttribute('data-pack-units')) || 0;
      if (!(units > 1)) return;
      var scope =
        meta.closest(
          '.product-card-wrapper, .card-wrapper, [class*="ai-recently-viewed-product"]',
        ) || meta.parentElement;
      var handle = handleFromScope(scope);
      if (handle) rememberHandleUnits(handle, units);
    });
  }

  function isPackMetaCard(card) {
    if (!card || !card.matches) return false;
    if (
      card.matches(
        '.product-card-wrapper, .card-wrapper, [class*="ai-recently-viewed-product"]',
      )
    ) {
      return true;
    }
    return Boolean(
      card.closest &&
        card.closest('.related-products, .product-grid, [data-rv-grid], [class*="ai-recently-viewed-"]'),
    );
  }

  function ensureListingPackMetaOnCards(options) {
    var opts = options || {};
    var updated = 0;
    var missing = [];

    seedUnitsFromRenderedCardMeta();

    findListingCards().forEach(function (entry) {
      if (!isPackMetaCard(entry.card) || !findCardPriceRoot(entry.card)) return;

      var units = unitsForHandle(entry.handle);
      if (!(units > 0)) {
        missing.push(entry.handle);
        return;
      }
      if (writeCardPackMeta(entry, units)) updated += 1;
    });

    if (!opts.skipHydrate && missing.length) {
      hydrateListingUnits(missing);
    }

    updatePlusOnePrices();
    return updated;
  }

  function productHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function compositionRows(entry) {
    if (!entry || typeof entry !== 'object') return [];
    if (Array.isArray(entry)) return entry;
    if (Array.isArray(entry.components)) return entry.components;
    return [];
  }

  function readComposition(variantId) {
    var key = String(variantId);
    var gid = 'gid://shopify/ProductVariant/' + key;
    var maps = [window.SPP_PACK_COMPONENTS_BY_VARIANT, window.SPP_PACK_COMPOSITIONS];
    for (var i = 0; i < maps.length; i += 1) {
      var map = maps[i];
      if (!map) continue;
      if (map[key]) return map[key];
      if (map[gid]) return map[gid];
    }
    return null;
  }

  function seedComposition(variantId, units) {
    if (!variantId || !(units > 0)) return false;

    if (window.__SPP_THEME_HINTS) {
      window.__SPP_THEME_HINTS.variantId = variantId;
      window.__SPP_THEME_HINTS.totalUnits = units;
    }

    // Seed units for pricing only. Do not invent size rows — the app owns
    // COMPONENTS_BY_VARIANT / Pre Pack labels.
    var existing = readComposition(variantId);
    var rows = compositionRows(existing);
    if (rows.length) return true;

    window.SPP_PACK_COMPOSITIONS = window.SPP_PACK_COMPOSITIONS || {};
    var key = String(variantId);
    var gid = 'gid://shopify/ProductVariant/' + key;
    var next = Object.assign({}, existing || {}, { totalUnits: units });
    delete next.components;
    window.SPP_PACK_COMPOSITIONS[key] = next;
    window.SPP_PACK_COMPOSITIONS[gid] = next;
    return true;
  }

  function formatMoney(cents) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        window.Shopify.money_format ||
        '${{amount}}';
      return window.Shopify.formatMoney(amount, format);
    }
    return '$' + (amount / 100).toFixed(2);
  }

  function currentVariantId() {
    var input =
      document.querySelector('.product__info-container form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('product-info input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return String(input.value);
    var hints = window.__SPP_THEME_HINTS || {};
    return hints.variantId ? String(hints.variantId) : '';
  }

  function sumEntryUnits(entry) {
    var total = Number(entry && entry.totalUnits) || 0;
    if (total > 0) return total;
    return compositionRows(entry).reduce(function (sum, row) {
      var quantity = Number(row && row.quantity);
      return sum + (quantity > 0 ? quantity : 0);
    }, 0);
  }

  function unitsFromComponentsMap(variantId) {
    var map = window.SPP_PACK_COMPONENTS_BY_VARIANT || {};
    if (!map || typeof map !== 'object') return 0;

    if (variantId) {
      var key = String(variantId);
      var gid = 'gid://shopify/ProductVariant/' + key;
      var direct = sumEntryUnits(map[key] || map[gid]);
      if (direct > 0) return direct;
    }

    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i += 1) {
      var total = sumEntryUnits(map[keys[i]]);
      if (total > 0) return total;
    }
    return 0;
  }

  // Keep SPP_PACK_COMPOSITIONS in sync so the app can still render pack meta
  // when showPrice is off (it clears the block if composition is missing).
  function syncCompositionsFromComponents() {
    var map = window.SPP_PACK_COMPONENTS_BY_VARIANT;
    if (!map || typeof map !== 'object') return;
    window.SPP_PACK_COMPOSITIONS = window.SPP_PACK_COMPOSITIONS || {};
    Object.keys(map).forEach(function (id) {
      var rows = compositionRows(map[id]);
      var total = sumEntryUnits(map[id]);
      if (!(total > 0)) return;
      var existing = window.SPP_PACK_COMPOSITIONS[id];
      if (existing && Number(existing.totalUnits) === total && compositionRows(existing).length) {
        return;
      }
      window.SPP_PACK_COMPOSITIONS[id] = {
        totalUnits: total,
        components: rows,
        hasSizes: rows.some(function (row) {
          return Boolean(row && row.size);
        }),
      };
    });
  }

  function knownUnitsForHandle(handle, hints) {
    var units = Number(hints && hints.totalUnits) || 0;
    if (units > 0) return units;

    units = unitsFromComponentsMap(currentVariantId() || (hints && hints.variantId));
    if (units > 0) return units;

    if (handle) {
      units = Number(readUnitsCache()[handle]) || 0;
      if (units > 0) return units;
    }

    var compositions = window.SPP_PACK_COMPOSITIONS || {};
    var components = window.SPP_PACK_COMPONENTS_BY_VARIANT || {};
    var keys = Object.keys(compositions).concat(Object.keys(components));
    for (var i = 0; i < keys.length; i += 1) {
      var total = sumEntryUnits(compositions[keys[i]] || components[keys[i]]);
      if (total > 0) return total;
    }

    var listing = window.SPP_LISTING_COMPOSITIONS;
    if (handle && listing && listing[handle]) {
      units = Number(listing[handle].totalUnits) || 0;
      if (units > 0) return units;
    }

    return 0;
  }

  function resolvePackPriceCents(priceEl, info) {
    var plus =
      (priceEl && priceEl.querySelector('.price-item--plus-one[data-price-cents]')) ||
      document.querySelector('.product__info-container .price-item--plus-one[data-price-cents]');
    if (plus) {
      var fromAttr = Number(plus.getAttribute('data-price-cents'));
      if (Number.isFinite(fromAttr)) return fromAttr;
    }

    var regular =
      (priceEl && priceEl.querySelector('.price-item--regular, .price-item--sale')) || null;
    if (regular) {
      var regularMatch = String(regular.childNodes[0] && regular.childNodes[0].textContent
        ? regular.childNodes[0].textContent
        : regular.textContent || ''
      ).match(/\$\s?([\d,]+(?:\.\d{2})?)/);
      if (regularMatch) {
        return Math.round(parseFloat(regularMatch[1].replace(/,/g, '')) * 100);
      }
    }

    var moneyMatch = String(
      (priceEl && priceEl.textContent) || (info && info.textContent) || '',
    ).match(/\$\s?([\d,]+(?:\.\d{2})?)/);
    if (moneyMatch) {
      return Math.round(parseFloat(moneyMatch[1].replace(/,/g, '')) * 100);
    }

    var selectedVariant = null;
    try {
      selectedVariant = JSON.parse(
        document.querySelector('[data-selected-variant]')?.textContent || 'null',
      );
    } catch (error) {
      selectedVariant = null;
    }
    if (selectedVariant && Number.isFinite(Number(selectedVariant.price))) {
      return Number(selectedVariant.price);
    }

    var amount = document.querySelector('variant-selects')?.dataset?.selectedPriceAmount;
    if (amount != null && amount !== '' && Number.isFinite(Number(amount))) {
      return Math.round(Number(amount) * 100);
    }

    var meta = document.querySelector('meta[property="og:price:amount"]')?.content;
    if (meta != null && Number.isFinite(Number(meta))) {
      return Math.round(Number(meta) * 100);
    }

    return null;
  }

  function unitsFromText(text) {
    var value = String(text || '');
    var pieces = value.match(/(\d+)\s+pieces?/i);
    if (pieces) return Number(pieces[1]);
    var units = value.match(/(\d+)\s+units?\s+per\s+pack/i);
    if (units) return Number(units[1]);
    return 0;
  }

  function handleFromScope(scope) {
    if (!scope || !scope.querySelector) return '';
    var link =
      scope.querySelector('a[href*="/products/"]') ||
      (scope.matches && scope.matches('a[href*="/products/"]') ? scope : null);
    if (!link) return '';
    var match = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function isListingCardContext(el) {
    return Boolean(
      el &&
        el.closest &&
        el.closest(
          '.product-card-wrapper, .card-wrapper, .related-products, [class*="ai-recently-viewed-product"], [data-rv-grid]',
        ),
    );
  }

  function unitsForPlusOne(el) {
    // Prefer the card/product root — pack meta is a sibling of `.price`, so
    // scoping to `.price` itself misses "per prepack (N pieces)".
    var scope =
      el.closest(
        '.card-wrapper, .product-card-wrapper, .card-information, product-info, .product__info-container',
      ) || el.closest('.price') || el.parentElement;
    var isCard = isListingCardContext(el);

    if (scope) {
      var meta = scope.querySelector(
        '.spp-listing-per-pack, .spp-listing-pack-meta, .spp-pack-info-units, #spp-pack-info',
      );
      if (!meta) {
        var priceRoot = el.closest('.price');
        if (priceRoot && priceRoot.nextElementSibling) {
          var sibling = priceRoot.nextElementSibling;
          if (
            sibling.classList.contains('spp-listing-pack-meta') ||
            sibling.id === 'spp-pack-info'
          ) {
            meta = sibling;
          }
        }
      }
      // On cards, ignore the PDP #spp-pack-info block — it belongs to the
      // current product and would leak its unit count into every YMAL card.
      if (isCard && meta && meta.id === 'spp-pack-info') meta = null;
      if (isCard && meta && meta.closest && meta.closest('product-info, .product__info-container')) {
        meta = null;
      }
      var fromMeta = unitsFromText(meta && meta.textContent);
      if (fromMeta > 0) return fromMeta;
    }

    // Cards must resolve units by their own handle — never the open PDP.
    var handle = handleFromScope(scope);
    if (!handle && !isCard) handle = productHandleFromPath();

    var listed = unitsForHandle(handle);
    if (listed > 0) return listed;

    if (!isCard) {
      var variantId = currentVariantId();
      var fromComponents = unitsFromComponentsMap(variantId);
      if (fromComponents > 0) return fromComponents;

      if (variantId) {
        var compositionUnits = sumEntryUnits(readComposition(variantId));
        if (compositionUnits > 0) return compositionUnits;
      }

      var hints = window.__SPP_THEME_HINTS || {};
      var known = knownUnitsForHandle(handle, hints);
      if (known > 0) return known;
    }

    // Ignore Liquid's fallback of 1 — that was only a placeholder until JS
    // resolved the real pack size.
    var attr = Number(el.getAttribute('data-pack-units')) || 0;
    return attr > 1 ? attr : 0;
  }

  function updatePlusOnePrices() {
    document.querySelectorAll('.price-item--plus-one[data-price-cents]').forEach(function (el) {
      var base = Number(el.getAttribute('data-price-cents'));
      if (!Number.isFinite(base)) return;
      var units = unitsForPlusOne(el);
      if (!(units > 0)) return;
      var next = formatMoney(base + units * 100);
      if (!next) return;
      if (el.textContent !== next) el.textContent = next;
      if (el.getAttribute('data-pack-units') !== String(units)) {
        el.setAttribute('data-pack-units', String(units));
      }
    });
  }

  function ensurePackInfoVisible(units) {
    var hints = window.__SPP_THEME_HINTS || {};
    var variantId = currentVariantId() || (hints.variantId ? String(hints.variantId) : '');
    syncCompositionsFromComponents();

    var resolvedUnits =
      Number(units) ||
      unitsFromComponentsMap(variantId) ||
      knownUnitsForHandle(hints.handle || productHandleFromPath(), hints) ||
      0;

    var priceEl =
      document.querySelector('.product__info-container .price') ||
      document.querySelector('.product__info-container [id^="price-"]') ||
      document.querySelector('product-info .price') ||
      document.querySelector('.price');

    var info = document.getElementById('spp-pack-info');
    if (!info && priceEl && priceEl.parentNode) {
      info = document.createElement('div');
      info.id = 'spp-pack-info';
      info.className = 'spp-pack-info';
      priceEl.parentNode.insertBefore(info, priceEl.nextSibling);
    }
    if (!info) {
      updatePlusOnePrices();
      return;
    }

    // Theme owns the selling price (and +$1/piece strike). Only restore pack
    // meta lines here — never inject/hide a competing pack price.
    if (priceEl) {
      priceEl.style.removeProperty('display');
      priceEl.removeAttribute('data-spp-hidden');
    }

    var composition =
      (variantId ? readComposition(variantId) : null) ||
      (variantId && window.SPP_PACK_COMPONENTS_BY_VARIANT
        ? window.SPP_PACK_COMPONENTS_BY_VARIANT[String(variantId)]
        : null);
    var rows = compositionRows(composition);
    if (!resolvedUnits && rows.length) resolvedUnits = sumEntryUnits(composition);

    var packPriceCents = resolvePackPriceCents(priceEl, info);
    var html = [];
    if (resolvedUnits > 0 && packPriceCents != null) {
      var perPiece = formatMoney(Math.round(packPriceCents / resolvedUnits));
      if (perPiece) {
        html.push('<span class="spp-pack-info-per-piece">' + perPiece + ' per piece</span>');
      }
      html.push(
        '<span class="spp-pack-info-units">' +
          resolvedUnits +
          ' unit' +
          (resolvedUnits === 1 ? '' : 's') +
          ' per pack</span>',
      );
    }

    var breakdown = rows
      .map(function (row) {
        var size = String((row && (row.size || row.title)) || '').trim();
        var quantity = Number(row && row.quantity);
        if (!size || !(quantity > 0)) return null;
        return size + ':' + quantity;
      })
      .filter(Boolean)
      .join(', ');
    if (breakdown) {
      html.push('<span class="spp-pack-info-breakdown">' + breakdown + '</span>');
    }

    var availableMatch = String((info && info.textContent) || '').match(
      /(\d+)\s+packs?\s+available/i,
    );
    if (availableMatch) {
      html.push(
        '<span class="spp-pack-info-available">' +
          availableMatch[1] +
          ' pack' +
          (Number(availableMatch[1]) === 1 ? '' : 's') +
          ' available</span>',
      );
    }

    if (html.length) {
      info.hidden = false;
      info.removeAttribute('data-spp-hidden');
      if (info.innerHTML !== html.join('')) info.innerHTML = html.join('');
    }
    updatePlusOnePrices();
  }

  function retriggerPackProduct() {
    var probe = document.createElement('div');
    probe.setAttribute('data-spp-repair-probe', 'true');
    probe.hidden = true;
    document.body.appendChild(probe);
    window.setTimeout(function () {
      probe.remove();
    }, 0);
  }

  function collectionCandidates(hints) {
    var candidates = [];
    var tags = (hints && hints.collectionHandles) || [];
    for (var i = 0; i < tags.length; i += 1) {
      if (tags[i]) candidates.push('/collections/' + encodeURIComponent(tags[i]));
    }
    candidates.push('/collections/all');
    return candidates;
  }

  function rememberHandleUnits(handle, units) {
    if (!handle || !(units > 0)) return 0;
    var patch = {};
    patch[handle] = { totalUnits: units };
    mergeListingCompositions(patch);
    return units;
  }

  function parsePackUnitsFromProductHtml(html, handle) {
    if (!html) return 0;

    var listing = parseAssignment(html, 'SPP_LISTING_COMPOSITIONS');
    if (listing) mergeListingCompositions(listing);
    var listed = unitsForHandle(handle);
    if (listed > 0) return listed;

    // Read pack size from that product's PDP maps without writing them onto
    // the current page's SPP_PACK_* globals (would corrupt the open PDP).
    var components = parseAssignment(html, 'SPP_PACK_COMPONENTS_BY_VARIANT');
    var compositions = parseAssignment(html, 'SPP_PACK_COMPOSITIONS');
    var maps = [components, compositions];
    for (var m = 0; m < maps.length; m += 1) {
      var map = maps[m];
      if (!map || typeof map !== 'object') continue;
      var keys = Object.keys(map);
      for (var i = 0; i < keys.length; i += 1) {
        var total = sumEntryUnits(map[keys[i]]);
        if (total > 0) return rememberHandleUnits(handle, total);
      }
    }

    var hintsMatch = html.match(/totalUnits["'\s:=]+(\d+)/);
    if (hintsMatch) {
      var hinted = Number(hintsMatch[1]) || 0;
      if (hinted > 0) return rememberHandleUnits(handle, hinted);
    }

    return 0;
  }

  function fetchProductPackUnits(handle) {
    if (!handle) return Promise.resolve(0);
    return fetch('/products/' + encodeURIComponent(handle), {
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        if (!response.ok) return 0;
        return response.text().then(function (html) {
          return parsePackUnitsFromProductHtml(html, handle);
        });
      })
      .catch(function () {
        return 0;
      });
  }

  function fetchCollectionCompositions(hints) {
    var urls = collectionCandidates(hints);
    return urls.reduce(function (promise, url) {
      return promise.then(function (found) {
        if (found) return found;
        return fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (response) {
            if (!response.ok) return null;
            return response.text();
          })
          .then(function (html) {
            if (!html || html.indexOf('SPP_LISTING_COMPOSITIONS') === -1) return null;
            var parsed = parseAssignment(html, 'SPP_LISTING_COMPOSITIONS');
            if (!parsed) return null;
            mergeListingCompositions(parsed);
            return parsed;
          })
          .catch(function () {
            return null;
          });
      });
    }, Promise.resolve(null));
  }

  function fetchUnitsForHandle(handle, hints) {
    if (unitsFetchInFlight) return unitsFetchInFlight;

    unitsFetchInFlight = fetchCollectionCompositions(hints)
      .then(function () {
        var units = unitsForHandle(handle);
        if (units > 0) return units;
        return fetchProductPackUnits(handle).then(function (productUnits) {
          return productUnits > 0 ? productUnits : null;
        });
      })
      .then(function (units) {
        unitsFetchInFlight = null;
        return units;
      })
      .catch(function () {
        unitsFetchInFlight = null;
        return null;
      });

    return unitsFetchInFlight;
  }

  function hydrateListingUnits(handles) {
    var needed = (handles || []).filter(function (handle, index, all) {
      return handle && all.indexOf(handle) === index && !(unitsForHandle(handle) > 0);
    });
    if (!needed.length) return Promise.resolve(0);
    if (hydrateInFlight) return hydrateInFlight;

    var hints = window.__SPP_THEME_HINTS || {};
    hydrateInFlight = fetchCollectionCompositions(hints)
      .then(function () {
        return needed.reduce(function (promise, handle) {
          return promise.then(function () {
            if (unitsForHandle(handle) > 0) return;
            return fetchProductPackUnits(handle);
          });
        }, Promise.resolve());
      })
      .then(function () {
        hydrateInFlight = null;
        ensureListingPackMetaOnCards({ skipHydrate: true });
        return needed.filter(function (handle) {
          return unitsForHandle(handle) > 0;
        }).length;
      })
      .catch(function () {
        hydrateInFlight = null;
        return 0;
      });

    return hydrateInFlight;
  }

  function applyPackForCurrentVariant(units) {
    var variantId = currentVariantId();
    if (!(units > 0) || !variantId) return false;

    if (window.__SPP_THEME_HINTS) {
      window.__SPP_THEME_HINTS.variantId = variantId;
      window.__SPP_THEME_HINTS.totalUnits = units;
    }

    seedComposition(variantId, units);
    retriggerPackProduct();
    ensurePackInfoVisible(units);
    return true;
  }

  function repairProductPackState() {
    var hints = window.__SPP_THEME_HINTS || {};
    var isPack =
      hints.isPackProduct === true ||
      window.SPP_IS_PACK_PRODUCT === true;

    if (!isPack) return false;

    window.SPP_IS_PACK_PRODUCT = true;
    document.documentElement.classList.add('spp-pack-product');

    var components = window.SPP_PACK_COMPONENTS_BY_VARIANT;
    var compositions = window.SPP_PACK_COMPOSITIONS;
    var hasComponents =
      components && typeof components === 'object' && Object.keys(components).length > 0;
    var hasCompositions =
      compositions && typeof compositions === 'object' && Object.keys(compositions).length > 0;

    if (!hasComponents || !hasCompositions) {
      var source = findInlineScript('SPP_PACK_COMPONENTS_BY_VARIANT');
      if (source) {
        if (!hasCompositions) {
          var parsedCompositions = parseAssignment(source, 'SPP_PACK_COMPOSITIONS');
          if (parsedCompositions && Object.keys(parsedCompositions).length) {
            window.SPP_PACK_COMPOSITIONS = parsedCompositions;
            hasCompositions = true;
          }
        }
        if (!hasComponents) {
          var parsedComponents = parseAssignment(source, 'SPP_PACK_COMPONENTS_BY_VARIANT');
          if (parsedComponents && Object.keys(parsedComponents).length) {
            window.SPP_PACK_COMPONENTS_BY_VARIANT = parsedComponents;
            hasComponents = true;
          }
        }
      }
    }

    syncCompositionsFromComponents();
    hasCompositions =
      window.SPP_PACK_COMPOSITIONS &&
      typeof window.SPP_PACK_COMPOSITIONS === 'object' &&
      Object.keys(window.SPP_PACK_COMPOSITIONS).length > 0;

    var handle = hints.handle || productHandleFromPath();
    var variantId = currentVariantId() || (hints.variantId ? String(hints.variantId) : '');
    var units = knownUnitsForHandle(handle, hints);

    // Always restore pack meta under the theme price when we know units /
    // components. The app clears this block when showPrice is false and
    // composition is momentarily missing.
    if (units > 0 || hasComponents) {
      if (units > 0 && variantId) seedComposition(variantId, units);
      ensurePackInfoVisible(units);
      retriggerPackProduct();
      return true;
    }

    if (handle && variantId && !unitsFetchInFlight) {
      fetchUnitsForHandle(handle, hints).then(function (fetchedUnits) {
        if (!(fetchedUnits > 0)) return;
        applyPackForCurrentVariant(fetchedUnits);
      });
    }

    return Boolean(isPack);
  }

  function retriggerListing() {
    document.querySelectorAll('[data-spp-listing-done], [data-spp-listing-pending]').forEach(function (el) {
      el.removeAttribute('data-spp-listing-done');
      el.removeAttribute('data-spp-listing-pending');
    });
    retriggerPackProduct();
  }

  function upgradeRecentlyViewedCards() {
    var compositions = window.SPP_LISTING_COMPOSITIONS || {};
    var labels = listingLabels();
    var updated = 0;

    document.querySelectorAll('a[data-rv-handle], a[class*="ai-recently-viewed-product"]').forEach(function (card) {
      var handle =
        card.getAttribute('data-rv-handle') ||
        (String(card.getAttribute('href') || '').match(/\/products\/([^/?#]+)/) || [])[1];
      if (!handle) return;
      handle = decodeURIComponent(handle);

      var units =
        sumEntryUnits(compositions[handle]) || Number(readUnitsCache()[handle]) || 0;
      var priceRoot =
        card.querySelector('[class*="ai-recently-viewed-product-price"], .price') || null;
      if (!priceRoot) return;

      var moneyMatch = String(priceRoot.textContent || '').match(/\$\s?([\d,]+(?:\.\d{2})?)/);
      var base = null;
      var plus = priceRoot.querySelector('.price-item--plus-one[data-price-cents]');
      if (plus) base = Number(plus.getAttribute('data-price-cents'));
      if (!Number.isFinite(base) && moneyMatch) {
        base = Math.round(parseFloat(moneyMatch[1].replace(/,/g, '')) * 100);
      }
      if (!Number.isFinite(base)) return;

      if (!(units > 0)) {
        // Keep whatever pack-units the card already declared.
        units = Number(plus && plus.getAttribute('data-pack-units')) || 0;
      }
      if (!(units > 0)) return;

      plus = ensurePlusOneMarkup(priceRoot, base);
      if (plus) {
        var struck = formatMoney(base + units * 100);
        if (struck) plus.textContent = struck;
        plus.setAttribute('data-pack-units', String(units));
        plus.setAttribute('data-price-cents', String(base));
      }

      var meta =
        (priceRoot.nextElementSibling &&
        priceRoot.nextElementSibling.classList.contains('spp-listing-pack-meta')
          ? priceRoot.nextElementSibling
          : null) ||
        card.querySelector('.spp-listing-pack-meta');
      if (!meta) {
        meta = document.createElement('div');
        meta.className = 'spp-listing-pack-meta';
        priceRoot.insertAdjacentElement('afterend', meta);
      }

      var perPack =
        units === 1
          ? labels.perPrepackSingular
          : String(labels.perPrepackPlural).replace('{{ count }}', String(units));
      var perPiece = formatMoney(Math.round(base / units));
      var html =
        '<span class="spp-listing-per-pack">' +
        perPack +
        '</span><span class="spp-listing-per-piece">' +
        String(labels.perPiece).replace('{{ price }}', perPiece) +
        '</span>';
      if (meta.innerHTML !== html) meta.innerHTML = html;
      updated += 1;
    });

    return updated;
  }

  function run() {
    preferThemePriceSettings();
    var listingRepaired = repairListingCompositions();
    var productRepaired = repairProductPackState();
    if (listingRepaired) retriggerListing();
    // Don't rely on the app alone — broken listing JSON often leaves cards
    // without pack meta and with a flat +$1 strike.
    ensureListingPackMetaOnCards();
    upgradeRecentlyViewedCards();
    updatePlusOnePrices();
    return listingRepaired || productRepaired;
  }

  function scheduleRepair(delay) {
    window.setTimeout(run, typeof delay === 'number' ? delay : 50);
  }

  function bindVariantListeners() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        // Wait for Dawn to finish swapping #price-* innerHTML
        scheduleRepair(0);
        scheduleRepair(120);
        scheduleRepair(350);
      });
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;
      if (target.matches && target.matches('input[name="id"]')) {
        scheduleRepair(0);
        scheduleRepair(150);
      }
      if (
        target.matches &&
        (target.matches('input[type="radio"][name^="options"]') ||
          target.matches('variant-selects input, variant-selects select'))
      ) {
        scheduleRepair(150);
        scheduleRepair(400);
      }
    });

    // Keep pack info if a section render removes it after a colorway swap
    var productRoot =
      document.querySelector('product-info') ||
      document.querySelector('.product__info-container');
    if (productRoot && typeof MutationObserver === 'function') {
      var debounce = null;
      var observer = new MutationObserver(function () {
        if (!window.SPP_IS_PACK_PRODUCT) return;
        var info = document.getElementById('spp-pack-info');
        var ok =
          info && /per piece|units per pack/i.test(info.textContent || '');
        // Pack meta can be present while the +$1/piece strike is still wrong.
        updatePlusOnePrices();
        if (ok) return;
        window.clearTimeout(debounce);
        debounce = window.setTimeout(run, 80);
      });
      observer.observe(productRoot, { childList: true, subtree: true });
    }
  }

  window.__SPP_REPAIR = {
    run: run,
    ensurePackInfoVisible: ensurePackInfoVisible,
    ensureListingPackMetaOnCards: ensureListingPackMetaOnCards,
    upgradeRecentlyViewedCards: upgradeRecentlyViewedCards,
    applyPackForCurrentVariant: applyPackForCurrentVariant,
  };

  function bindCardPackMetaObservers() {
    if (typeof MutationObserver !== 'function') return;
    var roots = document.querySelectorAll(
      '.related-products, [data-rv-grid], [class*="ai-recently-viewed-grid"], [class*="ai-recently-viewed-"]',
    );
    if (!roots.length) return;
    Array.prototype.forEach.call(roots, function (root) {
      var debounce = null;
      var observer = new MutationObserver(function () {
        window.clearTimeout(debounce);
        debounce = window.setTimeout(function () {
          preferThemePriceSettings();
          repairListingCompositions();
          ensureListingPackMetaOnCards();
          upgradeRecentlyViewedCards();
          updatePlusOnePrices();
        }, 100);
      });
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
      bindVariantListeners();
      bindCardPackMetaObservers();
    }, { once: true });
  } else {
    run();
    bindVariantListeners();
    bindCardPackMetaObservers();
  }

  var attempts = 0;
  var timer = window.setInterval(function () {
    attempts += 1;
    run();
    var listingOk =
      window.SPP_LISTING_COMPOSITIONS &&
      Object.keys(window.SPP_LISTING_COMPOSITIONS).length > 0 &&
      document.querySelectorAll('.spp-listing-pack-meta').length > 0;
    var productOk =
      window.SPP_IS_PACK_PRODUCT &&
      document.getElementById('spp-pack-info') &&
      /per piece|units per pack/i.test(document.getElementById('spp-pack-info').innerHTML || '');
    // Stop the boot poll once listing is healthy, or after enough attempts.
    // Product pack info is kept alive via variant listeners afterward.
    if (attempts >= 15 || listingOk || (productOk && attempts >= 5)) {
      window.clearInterval(timer);
    }
  }, 300);
})();
